/* eslint-disable no-undef */
(function (window) {
	"use strict";
	function defineSecurityService() {
		let securityService = {};
		securityService.generatePassword = function (request) {
			return axios.post("/api/SecurityService/GeneratePassword", request);
		};
		securityService.generateCustomerCode = function () {
			return axios.get("/api/SecurityService/GenerateCustomerCode");
		};
		securityService.getRoles = function (){
			return [
				{
					roleId: roleHelper.role.admin,
					role: "Admin"
				},
				{
					roleId: roleHelper.role.salesRep,
					role: "Sales Rep"
				},
				{
					roleId: roleHelper.role.logisticsManager,
					role: "Logistics Manager"
				},
				// {
				// 	roleId: roleHelper.role.salesManager,
				// 	role: "Sales Manager"
				// },
				{
					roleId: roleHelper.role.finance,
					role: "Finance"
				},
				{
					roleId: roleHelper.role.logisticsFleetController,
					role: "Logistics Fleet Controller"
				},
				{
					roleId: roleHelper.role.logisticsOfficeAdministrator,
					role: "Logistics Office Administrator"
				},
				{
					roleId: roleHelper.role.operationsManager,
					role: "Operations Manager"
				},
                {
                    roleId: roleHelper.role.logisticsPlanner,
                    role: "Logistics Planner"
                }
			];
		}
		securityService.getRolePermissions = function () {
			return axios.get("/api/SecurityService/GetRolePermissions");
		};
		securityService.addOrUpdateUser = function (request) {
			return axios.post("/api/SecurityService/AddOrUpdateUser", request);
		};
		securityService.addOrUpdateCustomerUser = function (request) {
			return axios.post("/api/SecurityService/AddOrUpdateCustomerUser", request);
		};
		securityService.addOrUpdateDepotSupervisor = function (request) {
			return axios.post("/api/SecurityService/AddOrUpdateDepotSupervisor", request);
		};
		securityService.addOrUpdateSalesRep = function (request) {
			return axios.post("/api/SecurityService/AddOrUpdateSalesRep", request);
		};
		securityService.markUserAsActiveOrInactive = function (request) {
			return axios.post("/api/SecurityService/MarkUserAsActiveOrInactive", request);
		};
		securityService.getAllCustomerUsers = function (request) {
			return axios.post("/api/SecurityService/GetAllCustomerUsers", request);
		};
		securityService.getAllDepotSupervisors = function (request) {
			return axios.post("/api/SecurityService/GetAllDepotSupervisors", request);
		};
		securityService.getAllInternalUsers = function (request) {
			return axios.post("/api/SecurityService/GetAllInternalUsers", request);
		};
		securityService.getUser = function (userId) {
			return axios.get("/api/SecurityService/GetUser?userId=" + userId);
		};
		securityService.resetPassword = function (request) {
			return axios.post("/api/SecurityService/ResetPassword", request);
		};
		securityService.getCompaniesAssignedToSalesRep = function (request) {
			return axios.post("/api/SecurityService/GetCompaniesAssignedToSalesRep", request);
		};
		securityService.getCompaniesUnassignedToSalesReps = function () {
			return axios.get("/api/SecurityService/GetCompaniesUnassignedToSalesReps");
		};
		securityService.getCompaniesUnassignedToSalesRep = function (request) {
			return axios.post("/api/SecurityService/GetCompaniesUnassignedToSalesRep", request);
		};
		securityService.assignAndUnassignCompaniesToSalesRep = function (request) {
			return axios.post("/api/SecurityService/AssignAndUnassignCompaniesToSalesRep", request);
		};
		securityService.assignAndUnassignSalesRepsFromCompany = function (request) {
			return axios.post("/api/SecurityService/AssignAndUnassignSalesRepsFromCompany", request);
		};
		securityService.markDepotUserAsActiveOrInactive = function (request) {
			return axios.post("/api/SecurityService/MarkDepotUserAsActiveOrInactive", request);
		};
		securityService.getSalesRepsAssignedToCompany = function (request) {
			return axios.post("/api/SecurityService/GetSalesRepsAssignedToCompany", request);
		};
		securityService.getCompanySalesReps = function (request) {
			return axios.post("/api/SecurityService/GetCompanySalesReps", request);
		};
		securityService.getCustomerUser = function (request) {
			return axios.post("/api/SecurityService/GetCustomerUser", request);
		};
		securityService.getPrimaryCustomerUser = function (request) {
			return axios.post("/api/SecurityService/GetPrimaryCustomerUser", request);
		};
		securityService.updatePassword = function (request) {
			return axios.post("/api/SecurityService/UpdatePassword", request);
		};
		securityService.getUserOrderTypePermissions = function () {
			return axios.get("/api/SecurityService/GetUserOrderTypePermissions");
		};
		securityService.assignAndUnassignCompanyAddressesFromSalesRep = function (request) {
			return axios.post("/api/SecurityService/AssignAndUnassignCompanyAddressesFromSalesRep", request);
		};
		securityService.getCompanyShippingAddressesAssignedToSalesRep = function (request) {
			return axios.post("/api/SecurityService/GetCompanyShippingAddressesAssignedToSalesRep", request);
		};
		securityService.getCustomerSpecialPricingPermissionsByRole = function () {
			return axios.get("/api/SecurityService/GetCustomerSpecialPricingPermissionsByRole");
		};
		return securityService;
	}
	//define globally if it doesn't already exist
	if (typeof (securityService) === "undefined") {
		window.securityService = defineSecurityService();
	} else {
		console.log("securityService already defined.");
	}
})(window);